import { ApiError } from '../openapi';
import { MediaType, ResponseObjectMap, SuccessResponse } from 'openapi-typescript-helpers';
import { FetchResponse, ParseAsResponse } from 'openapi-fetch';

export function mapResponse<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string | number, any>,
  Options,
  Media extends MediaType,
>(
  res: FetchResponse<T, Options, Media>,
): ParseAsResponse<SuccessResponse<ResponseObjectMap<T>, Media>, Options> {
  if (res.error) {
    throw new ApiError('unexpected error', res.response.status);
  }

  if (res.response.status === 204 || res.response.status === 202) {
    return null as unknown as ParseAsResponse<
      SuccessResponse<ResponseObjectMap<T>, Media>,
      Options
    >;
  }

  if (typeof res.data === 'undefined') {
    throw new ApiError('data is empty', res.response.status);
  }

  return res.data;
}
